module.exports = __webpack_public_path__ + "static/media/jason.ef532274.png";